var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"mark"}),_c('lang-select',{class:{ 'bg-white': _vm.hasWhiteBg },attrs:{"active-scroll":_vm.hasWhiteBg}}),_c('img',{ref:"headerImg",staticClass:"header-img",attrs:{"src":require("../assets/img/1920x400-page-banner.jpg"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }